<template>
  <div class="imprint">
    <div class="logo"/>
    <div class="app-version">
      <p>AFTV release 0.1.91</p>
      <button v-on:click="onReload" class="mt-2 secondary">Clear Cache &amp; Reload</button>
    </div>
  </div>
</template>

<script>

const RELOAD_DELAY_MS = 1000

export default {
  name: 'Imprint',
  methods: {
    onReload () {
      this.$store.commit('showLoading')
      if (navigator.serviceWorker && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage('CLEAR_CACHE')
      }

      setTimeout(() => {
        this.$store.commit('navigation/goToHome')
      }, RELOAD_DELAY_MS)
    }
  }
}
</script>
